import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-sku-chip",
  templateUrl: "./sku-chip.component.html",
  styleUrls: ["./sku-chip.component.scss"],
})
export class SkuChipComponent implements OnInit {
  @Input() name: string;
  @Input() value: string;
  @Input() link: any;
  @Input() showName:boolean=false;
  @Input() clickFunction: any;
  copied: boolean;
  constructor() {}

  ngOnInit(): void {}

  openLink(e: MouseEvent) {
    if(this.link?.includes('+')){
      let str = this.link; 
      this.link =  str.replaceAll('+','%2B')
    }
    if (this.link) {
      window.open(this.link);
    } else if (this.clickFunction) {
      this.clickFunction(e);
    }
  }

  copy(e: MouseEvent) {
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, 800);
  }

  cancelEvent(e: MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
  }
}
